/* Hallmark · component: SecretField · genre: modern-minimal · theme: maeiz-tokens
 * Password / secret input with show/hide toggle
 */
import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import { Input, type InputProps } from "../Input";

export interface SecretFieldProps extends Omit<InputProps, "type" | "suffix"> {
    defaultVisible?: boolean;
}

export const SecretField: React.FC<SecretFieldProps> = ({
    defaultVisible = false,
    label = "Password",
    prefix,
    ...props
}) => {
    const [visible, setVisible] = useState(defaultVisible);

    return (
        <Input
            {...props}
            label={label}
            type={visible ? "text" : "password"}
            autoComplete={props.autoComplete ?? "current-password"}
            prefix={prefix ?? <Lock aria-hidden strokeWidth={2} />}
            suffix={
                <button
                    type="button"
                    tabIndex={-1}
                    className="pointer-events-auto rounded-md p-0.5 text-primary hover:bg-primary/5 dark:text-gold-light dark:hover:bg-gold/10"
                    aria-label={visible ? "Hide secret" : "Show secret"}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setVisible((v) => !v);
                    }}
                >
                    {visible ? <EyeOff size={18} strokeWidth={2} /> : <Eye size={18} strokeWidth={2} />}
                </button>
            }
        />
    );
};

SecretField.displayName = "SecretField";
